import { useCallback, useEffect, useState } from 'react';

const VIEWPORT_PADDING = 8;
const DROPDOWN_OFFSET_Y = 8;
const DROPDOWN_OFFSET_X = 8;
const FALLBACK_DROPDOWN_WIDTH = 275;

const useFixedDropdownPosition = ({
  triggerRef,
  dropdownRef,
  isOpen,
  position = 'left',
}) => {
  const [dropdownStyle, setDropdownStyle] = useState({});

  const updateDropdownPosition = useCallback(() => {
    if (!triggerRef?.current || !dropdownRef?.current) {
      return;
    }

    const triggerRect = triggerRef.current.getBoundingClientRect();
    const dropdownWidth =
      dropdownRef.current.offsetWidth || FALLBACK_DROPDOWN_WIDTH;

    let left =
      position === 'right'
        ? triggerRect.right - dropdownWidth
        : triggerRect.left - DROPDOWN_OFFSET_X;

    left = Math.max(
      VIEWPORT_PADDING,
      Math.min(left, window.innerWidth - dropdownWidth - VIEWPORT_PADDING)
    );

    setDropdownStyle({
      top: `${triggerRect.bottom - DROPDOWN_OFFSET_Y}px`,
      left: `${left}px`,
    });
  }, [dropdownRef, position, triggerRef]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    updateDropdownPosition();

    window.addEventListener('resize', updateDropdownPosition);
    window.addEventListener('scroll', updateDropdownPosition, true);

    return () => {
      window.removeEventListener('resize', updateDropdownPosition);
      window.removeEventListener('scroll', updateDropdownPosition, true);
    };
  }, [isOpen, updateDropdownPosition]);

  return dropdownStyle;
};

export default useFixedDropdownPosition;
